import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchPost(payload) {
  return { type: actionTypes.FETCH_ONE, payload };
}

export function fetchPostSuccess(payload) {
  // console.log('payload', payload)
  const byId = { [payload.postUid]: payload };
  return { type: actionTypes.FETCH_ONE_SUCCESS, payload: { byId } };
}

export function fetchPosts(payload) {
  return { type: actionTypes.FETCH_COLLECTION, payload };
}

export function fetchPostsSuccess(posts, params) {
  // console.log('post...', posts, params)
  const byId = keyBy(posts, (post) => post.postUid);
  // console.log('byid....', byId)
  return { type: actionTypes.FETCH_COLLECTION_SUCCESS, payload: { byId, params } };
}

export function createPost(token, data) {
  return { type: actionTypes.CREATE, payload: { token: token, data: data, retry: 3 } };
}

export function createPostSuccess(payload) {
  // console.log('payload...', payload)
  return { type: actionTypes.CREATE_SUCCESS, payload };
}

export function updatePost(payload) {
  // console.log('action payload..', payload)
  return { type: actionTypes.UPDATE, payload };
}

export function updatePostSuccess(payload) {
  // console.log('update payload...', payload)
  return { type: actionTypes.UPDATE_SUCCESS, payload };
}

export function deletePost(payload) {
  return { type: actionTypes.DELETE, payload };
}

export function deletePostSuccess(payload) {
  // console.log('delete payload...', payload)
  return { type: actionTypes.DELETE_SUCCESS, payload };
}

export function postActionToggleLoading(payload) {
  // console.log('is__loading...', payload)
  return { type: actionTypes.POST_ACTION_TOGGLE_LOADING, payload }
}

export function getPostsSignedUrl(payload) {
  return { type: actionTypes.GET_POSTS_SIGNED_URL, payload };
}

export function getPostsSignedUrlSuccess(payload) {
  console.log('payload........', payload)
  return {
    type: actionTypes.GET_POSTS_SIGNED_URL_SUCCESS,
    payload: { url: payload },
  };
}

export function fetchPostsBySignedUrl(payload) {
  return {
    type: actionTypes.FETCH_POSTS_BY_SIGNED_URL,
    payload,
  };
}
export function fetchPostsBySignedUrlSuccess(posts) {  
  const byId = keyBy(posts, (post) => post.postUid);
  return {
    type: actionTypes.FETCH_POSTS_BY_SIGNED_URL_SUCCESS,
    payload: { byId },
  };
}